import { defineComponent as _defineComponent } from 'vue'
import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

import {
  AccountingPeriod,
} from "@/Enums";

import {
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";

import {
  copyObject,
} from "@/scripts/Common/HelperFunctions";

import {
  computed,
  PropType,
  ref,
  unref,
} from "vue";

import {
  SepaIssuerSettings,
} from "@/components/settings/scripts/Sepas";

import {
  useI18n,
} from "@/composables/useI18n";

import {
  hasAccessRights,
} from "@/authorization/AuthorizationService";

import {
  editSettingsPolicy,
} from "@/authorization/policies";


export default /*#__PURE__*/_defineComponent({
  __name: 'SepaIssuerSettings',
  props: {
  token: {
    required: true,
    type: String as PropType<string>,
  }
},
  emits: [
  'onSuccessfulUpdate',
  'onError',
],
  setup(__props, { emit: emits }) {

const props = __props;



const {
  t
} = useI18n();



const sepaSettings = ref<SepaIssuerSettings>({
  debitAccountingPeriod: AccountingPeriod.daily
});
let serverSepaSettings: SepaIssuerSettings = {
  debitAccountingPeriod: AccountingPeriod.daily
};

const accountingPeriodSelection = computed(() => [
  {state: t('option_daily'), value: AccountingPeriod.daily},
  {state: t('option_weekly'), value: AccountingPeriod.weekly},
  {state: t('option_biweekly'), value: AccountingPeriod.biweekly},
  {state: t('option_monthly'), value: AccountingPeriod.monthly}
]);

const settingsHaveChanges = computed (() => {
  return sepaSettings.value.debitAccountingPeriod !== serverSepaSettings.debitAccountingPeriod;
});

const fetchSepaSettings = async () => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'sepaIssuerSettingsResource',
    bearer: props.token
  });

  if (error) {
    emits('onError', {error});
    return;
  }

  sepaSettings.value = response;
  serverSepaSettings = copyObject(response);
};

const updateSepaSettings = async () => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'sepaIssuerSettingsResource',
    bearer: props.token,
    options: {
      method: httpMethod.PUT
    },
    body: JSON.stringify(unref(sepaSettings)),
  });

  if (error) {
    emits('onError', {error});
    return;
  }

  sepaSettings.value = response;
  serverSepaSettings = copyObject(response);
  emits('onSuccessfulUpdate');
};

const onHandleClickSave = () => {
  updateSepaSettings();
}

const onHandleClickReset = () => {
  sepaSettings.value = copyObject(serverSepaSettings);
}

return { __sfc: true,props, t, emits, sepaSettings, serverSepaSettings, accountingPeriodSelection, settingsHaveChanges, fetchSepaSettings, updateSepaSettings, onHandleClickSave, onHandleClickReset, FloatingActionButton, hasAccessRights, editSettingsPolicy }
}

})